import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { task, timeout } from 'ember-concurrency';
import moment from 'moment-timezone';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<form\n  {{did-update this.syncArgs @fromDate}}\n  {{did-update this.syncArgs @toDate}}\n  {{on \'submit\' this.handleSubmit}}\n>\n  <div class=\'grid-x grid-padding-x\'>\n    <div class=\'cell auto\'>\n      <BbInputDate\n        @originalDate={{this.localFromDate}}\n        @timeZone={{this.session.me.time_zone}}\n        @setDate={{fn (mut this.localFromDate)}}\n        @action={{perform this.focusOutFromDateTask}}\n        @setPika={{this.setPikaIn}}\n      />\n\n      <span role=\"alert\" class=\"field-error\">\n        {{this.fromDateError}}\n      </span>\n    </div>\n    <div class=\'cell auto\'>\n      <BbInputDate\n        @originalDate={{this.localToDate}}\n        @timeZone={{this.session.me.time_zone}}\n        @setDate={{fn (mut this.localToDate)}}\n        @action={{perform this.focusOutToDateTask}}\n        @setPika={{this.setPikaOut}}\n      />\n\n      <span role=\"alert\" class=\"field-error\">\n        {{this.toDateError}}\n      </span>\n    </div>\n    {{#if @showConfirm}}\n      <div class=\'cell auto align-center\'>\n        <button type=\'submit\' class=\'button expanded\'>\n          {{t \'apply\'}}\n        </button>\n      </div>\n    {{/if}}\n  </div>\n</form>");

var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1;
let BbDateRangeComponent = (_dec = task(function* () {
  yield timeout(50);
  this._syncPickersLimitations();
  this.pikaOut?.show();
}).restartable(), _dec2 = task(function* () {
  yield timeout(50);
  this._syncPickersLimitations();
  this.setRangeTask.perform();
}).restartable(), _dec3 = task(function* () {
  yield timeout(50);
  const fromDate = moment(this.localFromDate).startOf('day');
  const toDate = moment(this.localToDate).endOf('day');
  if (!this._validateRange(fromDate, toDate)) {
    return;
  }

  // moment(undefined) is "now", so an unset original date would spuriously
  // match a user picking today and swallow the selection; treat unset as changed.
  const originalFrom = this.args.fromDate ? moment(this.args.fromDate) : null;
  const originalTo = this.args.toDate ? moment(this.args.toDate) : null;
  if (!originalFrom?.isSame(fromDate, 'day') || !originalTo?.isSame(toDate, 'day')) {
    this.args.setFromDate?.(fromDate.format('YYYY-MM-DDTHH:mm:ssZ'));
    this.args.setToDate?.(toDate.format('YYYY-MM-DDTHH:mm:ssZ'));
    this.args.action?.();
  }
}).restartable(), _class = class BbDateRangeComponent extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _initializerDefineProperty(this, "session", _descriptor2, this);
    _initializerDefineProperty(this, "fromDateError", _descriptor3, this);
    _initializerDefineProperty(this, "toDateError", _descriptor4, this);
    _initializerDefineProperty(this, "pikaIn", _descriptor5, this);
    _initializerDefineProperty(this, "pikaOut", _descriptor6, this);
    _initializerDefineProperty(this, "localFromDate", _descriptor7, this);
    _initializerDefineProperty(this, "localToDate", _descriptor8, this);
    _initializerDefineProperty(this, "focusOutFromDateTask", _descriptor9, this);
    _initializerDefineProperty(this, "focusOutToDateTask", _descriptor0, this);
    _initializerDefineProperty(this, "setRangeTask", _descriptor1, this);
  }
  _syncPickersLimitations() {
    const fromDate = moment(this.localFromDate).startOf('day');
    const toDate = moment(this.localToDate).startOf('day');
    if (fromDate.isValid()) {
      this.pikaOut?.setMinDate(fromDate.toDate());
    }
    if (fromDate.isValid() && toDate.isValid()) {
      if (fromDate.isAfter(toDate)) {
        const newToDate = fromDate.clone().add(7, 'days');
        this.localToDate = newToDate.format('YYYY-MM-DD');
        this.pikaOut?.setMoment(newToDate);
      }
    }
  }
  syncArgs() {
    this.localFromDate = this.args.fromDate;
    this.localToDate = this.args.toDate;
    this._syncPickersLimitations();
  }
  handleSubmit(event) {
    event.preventDefault();
    this.setRangeTask.perform();
  }
  setPikaIn(pika) {
    this.pikaIn = pika;
  }
  setPikaOut(pika) {
    this.pikaOut = pika;
  }
  _validateRange(fromDate, toDate) {
    let hasError = false;
    if (!fromDate.isValid()) {
      this.fromDateError = this.intl.t('invalid date');
      hasError = true;
    } else {
      this.fromDateError = null;
    }
    if (!toDate.isValid()) {
      this.toDateError = this.intl.t('invalid date');
      hasError = true;
    } else {
      this.toDateError = null;
    }
    if (!hasError && fromDate.isAfter(toDate)) {
      this.fromDateError = this.intl.t('end date must be after start date');
      this.toDateError = this.intl.t('end date must be after start date');
      return false;
    }
    return !hasError;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "session", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "fromDateError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "toDateError", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "pikaIn", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "pikaOut", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "localFromDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.fromDate;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "localToDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.toDate;
  }
}), _applyDecoratedDescriptor(_class.prototype, "syncArgs", [action], Object.getOwnPropertyDescriptor(_class.prototype, "syncArgs"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleSubmit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleSubmit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPikaIn", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPikaIn"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setPikaOut", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setPikaOut"), _class.prototype), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "focusOutFromDateTask", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "focusOutToDateTask", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "setRangeTask", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
setComponentTemplate(TEMPLATE, BbDateRangeComponent);

export { BbDateRangeComponent as default };
//# sourceMappingURL=bb-date-range.js.map
